import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { HttpClient } from "@angular/common/http";
import { ActionCableService } from "angular2-actioncable";
import { ErrorService } from "./error.service";
import { AuthorizationService } from "./authorization.service";
import { map, Observable } from "rxjs";
import { ExplorerModel } from "../models/explorer-model";

@Injectable({
  providedIn: 'root'
})
export class ExplorerModelService extends ApiService {
  constructor(
    http: HttpClient,
    cableService: ActionCableService,
    errorService: ErrorService,
    authService: AuthorizationService
  ) {
    super(http, cableService, errorService, authService);
  }

  /**
   * Get an {@link ExplorerModel} with id {@link explorer_model_id}.
   * @param explorer_model_id id of the model to fetch. If null, fetches model id 0
   * @returns An {@link Observable} that will resolve to an {@link ExplorerModel} if the request is successful.
   */
  getExplorerModel(explorer_model_id: number): Observable<ExplorerModel> {
    return this.get(ExplorerModel, `/explorer_models/${explorer_model_id || 1}`);
  }

  /**
   * Given a {@link robot_id}, determine its {@link RobotModel} and get the attached {@link ExplorerModel}, or a default one, if none is set.
   * @param robot_id id of the robot to fetch for. Should be non-null.
   * @returns An {@link Observable} that will resolve to an {@link ExplorerModel} if the request is successful.
   */
  getExplorerModelForRobot(robot_id: number): Observable<ExplorerModel> {
    return this.list(ExplorerModel, `/explorer_models`, {
      for_robot: robot_id
    }).pipe(map(value => {
      if (value.length > 0) {
        return value[0];
      }
      else {
        return null;
      }
    }));
  }
  getAllModels(): Observable<ExplorerModel[]> {
    return this.list(ExplorerModel, `/explorer_models`);
  }
}